// extracted by mini-css-extract-plugin
export default {"alt":"index_alt__v5ssm","statsTitle":"index_statsTitle__TpLDB","statsValue":"index_statsValue__qL1a1"};